<template>
    <div>
        <Sidebar />
        
    </div>
</template>
<script>
    import Sidebar from '@/components/Sidebar.vue'
    import { utilFunctionService } from '@/utils/utils.service'

    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name : 'Layout',
        components: {
            Sidebar
        },
        mounted() {
            const roles = utilFunctionService.getUserRoles();
            if (!roles || !roles.includes('admin')) {
                utilFunctionService.removeLocalStorageService('user');
                this.$router.replace({ name: 'login' });
            }
        }
    }
</script>
